import { type FC } from 'react';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay';

// Components
import { PdpRespIconBubblePrint } from './PdpRespIconBubblePrint.tsx';

import { PdpRespIconBubbles } from './PdpRespIconBubbles.tsx';

import { type PdpRespIconBubblesWrapper_viewer$data } from './__generated__/PdpRespIconBubblesWrapper_viewer.graphql.ts';
import { type PdpRespIconBubblesWrapper_item$data } from './__generated__/PdpRespIconBubblesWrapper_item.graphql.ts';
import { type PdpRespIconBubblesWrapper_user$data } from './__generated__/PdpRespIconBubblesWrapper_user.graphql.ts';

import styles from './PdpRespIconBubblesWrapper.scss';

type Props = {
    relayVariables: {
        isTrade?: boolean;
        isPDPDesktopAggregationVariant?: boolean | null;
    };
    viewer: PdpRespIconBubblesWrapper_viewer$data;
    item: PdpRespIconBubblesWrapper_item$data;
    user: PdpRespIconBubblesWrapper_user$data | null | undefined;
    skuId: string | null;
    dataTn?: string;
};

const PdpRespIconBubblesWrapperComponent: FC<Props> = ({ dataTn, relayVariables, ...props }) => {
    const isPrivatePdp = props.item.isPublishedPrivate;
    if (isPrivatePdp) {
        return null;
    }

    const { isTrade, isPDPDesktopAggregationVariant } = relayVariables;

    return (
        <div
            className={classnames(styles.wrapper, {
                [styles.isPDPDesktopAggregationVariant]: isPDPDesktopAggregationVariant,
            })}
            data-tn={dataTn}
        >
            <PdpRespIconBubbles {...props} />
            <PdpRespIconBubblePrint isTrade={isTrade} />
        </div>
    );
};

export const PdpRespIconBubblesWrapper = createFragmentContainer(
    PdpRespIconBubblesWrapperComponent,
    {
        viewer: graphql`
            fragment PdpRespIconBubblesWrapper_viewer on Viewer {
                ...PdpRespIconBubbles_viewer
            }
        `,
        item: graphql`
            fragment PdpRespIconBubblesWrapper_item on Item {
                isPublishedPrivate
                ...PdpRespIconBubbles_item
            }
        `,
        user: graphql`
            fragment PdpRespIconBubblesWrapper_user on User {
                ...PdpRespIconBubbles_user
            }
        `,
    }
);
